import { object, string, array, bool } from 'yup';
import { treatmentRecordCommonSchema } from './treatmentRecordCommon';
import { nullToEmptyString, nullToArray } from './transforms';

export const NANO_NEEDLLING_LEVEL_FIELDS = [
  { id: 'NeedleDepth', label: 'Needle Depth' },
  // { id: 'DeviceSpeed', label: 'Device Speed' },
  // { id: 'PassCount', label: 'Number of passes' },
];

export const nanoTreatmentRecordSchema = object().shape({
  treatmentAttributes: object().shape({
    cleanseBaseProduct: array(string())
      .required('Cleanse Base Product')
      .min(1, 'Cleanse Base Product')
      .nullable(true)
      .transform(nullToArray),
    skinType: string().required('Skin Type').nullable(true),
    conditions: array(string())
      .required('Conditions')
      .min(1, 'Conditions')
      .nullable(true),
    topTreatmentFocus: string()
      .required('Top Treatment Focus')
      .nullable(true)
      .transform(nullToArray),
    openingRitualAromatherapy: array(string())
      .required('Opening Ritual Aromatherapy')
      .min(1, 'Opening Ritual Aromatherapy')
      .nullable(true)
      .transform(nullToArray),
    nanoneedlingPrepProduct: string()
      .when('nanoneedlingSegment', {
        is: (nanoneedlingSegment: boolean) => nanoneedlingSegment,
        then: string().required('Prep Product'),
      })
      .nullable(true)
      .transform(nullToEmptyString),
    nanoneedlingSerum: string()
      .when('nanoneedlingSegment', {
        is: (nanoneedlingSegment: boolean) => nanoneedlingSegment,
        then: string().required('Serum'),
      })
      .nullable(true)
      .transform(nullToEmptyString),
    exfoliationSegment: bool().nullable(true),
    nanoneedlingSegment: bool().nullable(true),
    maskSegment: bool().nullable(true),
    serum: array(string())
      .required('Serum')
      .min(1, 'Serum')
      .nullable(true)
      .transform(nullToArray),
  }),
  ...treatmentRecordCommonSchema.topLevel,
});
